import { createActionGroup, emptyProps } from '@ngrx/store';
import { BookingProductType } from '@products/models/booking.model';

export const ProductBookingActions = createActionGroup({
  source: 'Product Booking',
  events: {
    'Set product in booking list': (bookingProductTypes: BookingProductType[]) => ({ bookingProductTypes }),
    'Remove booked products and set preferred product in booking list': (
      bookingProductTypes: BookingProductType[]
    ) => ({ bookingProductTypes }),
    'Remove product from booking list': (bookingProductTypes: BookingProductType[]) => ({ bookingProductTypes })
  }
});

export const ProductBookingErrorActions = createActionGroup({
  source: 'Product Booking Error',
  events: {
    'Set product in booking list error': emptyProps(),
    'Remove product from booking list error': emptyProps()
  }
});
